export default __webpack_public_path__ + "static/media/recipesearch.9f0701db.PNG";